const l = {
  name: "Microphone",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.7 39.7" style="enable-background:new 0 0 39.7 39.7;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M34,17.4c3.3-1.3,5.7-4.6,5.7-8.4c0-5-4-9-9-9c-3.8,0-7.1,2.4-8.4,5.7l-0.9-0.9L14.3,12l2.1,2.1l-11,15
			L7.3,31L0,38.3l1.4,1.4l7.3-7.3l1.9,1.9l15-11l2.1,2.1l7.2-7.2L34,17.4z M32.4,15.8l-8.5-8.5C24.7,4.3,27.4,2,30.7,2
			c3.9,0,7,3.1,7,7C37.7,12.3,35.5,15,32.4,15.8z M17.1,12l4.3-4.3l10.6,10.6l-4.3,4.3L17.1,12z M8,28.9l9.8-13.4l6.4,6.4l-13.4,9.8
			L8,28.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Microphone
};
